<template>
  <!-- 实践课详情页面 -->
  <div class="detail">
    <home-header />
    <personal-center />
    <div class="content page-width">
      <div class="content-right pull-left">
        <a-spin :spinning="detailSpinning">
          <practice-detail-form ref="detailRef" :article="article" :reviewInfo="reviewInfo" @submitSuccess="getPracticeInfo" />
        </a-spin>
      </div>
      <div class="clearfix"></div>
    </div>
    <Foot />
  </div>
</template>

<script>
import HomeHeader from '@/common/components/Header'
import PersonalCenter from '@/common/components/PersonalCenter'
import PracticeDetailForm from './components/PracticeDetailForm.vue'
import Foot from '@/common/components/Foot'

export default {
  name: 'Index',
  components: {
    HomeHeader,
    PersonalCenter,
    PracticeDetailForm,
    Foot
  },
  data: function () {
    return {
      detailSpinning: true,
      article: {},
      reviewInfo: {}
    }
  },
  mounted () {
    this.getPracticeInfo()
  },
  methods: {
    // 查询实践课信息
    async getPracticeInfo() {
      this.detailSpinning = true
      try {
        const params = {
          id: this.$route.query.id,
          planId: this.$route.query.id,
          type: 'course'
        }
        const detailRes = await this.axios.get(`/biz/home/practiceCourse/detail`, { params: params })
        if (detailRes.success) {
          // 查询学生回传信息
          const backRes = await this.axios.get(`/biz/home/document/stuBackDocDetail`, { params: params })
          if (backRes.success) {
            this.reviewInfo = backRes.result || {}

            if (detailRes.result.visibles) {
              detailRes.result.visibles = JSON.parse(detailRes.result.visibles || '[]')
              detailRes.result.visibles.forEach(item => {
                item.value = this.reviewInfo[item.label] || undefined
              })
            }
            if (detailRes.result.configList) {
              detailRes.result.configList.forEach(item => {
                item.fileList = (this.reviewInfo.docList || []).filter(ite => ite.configId === item.id)
              })
            }
          }
          this.article = detailRes.result
          this.$refs.detailRef.formData = backRes.result
        }
      } finally {
        this.detailSpinning = false
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/varibles.styl';

.page-width {
  width: $pageWidth;
  margin: 0 auto;

  .content-right {
    margin-top: 30px;
    width: 100%;
    overflow: hidden;

    .localtion {
      line-height: 30px;
      border-bottom: 1px solid $borderColor;
      margin-bottom: 20px;
    }
  }
}

.content-left {
  background: #f7f6f6;
}

.content {
  background: #fff;
  padding: 28px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.detail {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/PracticeDetail/PracticeDetailIndex.vue